/*
 * @Author: lc
 * @Date: 2022-04-09 15:28:15
 * @LastEditors: lc
 * @LastEditTime: 2022-05-30 16:26:04
 * @Description: 
 */
//定制订单
import axios from '.././http' // 导入http中创建的axios实例
import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来

// 接口请求地址
const api = '/c-api/'

const madeorder = {
    // 列表
    list (params) {
        return axios.get(api + 'madeorder/list', { params: params })
    },
    // 发货
    ship (params) {
        return axios.post(api + 'madeorder/ship', qs.stringify(params))
    },
    // 定制
    make (params) {
        return axios.post(api + 'madeorder/make', qs.stringify(params))
    },
    // 取消
    cancel (params) {
        return axios.post(api + 'madeorder/cancel', qs.stringify(params))
    },
    //导出订单
    customizedOrder (params) {
        return axios.post(api + 'export/customizedOrder', qs.stringify(params))
    },
    //批量发货
    allship (params) {
        return axios.post(api + 'madeorder/allship', qs.stringify(params))
    },
    // 列表
    photo (params) {
        return axios.get(api + 'madeorder/photo', { params: params })
    },
}

// 导出接口
export default madeorder